import React, { useState, useCallback } from "react";

const DomainSearchInput = ({ setDomainObj, onValidDomain }) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const validateDomain = async (domainName) => {
    if (!domainName) {
      setError(null);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(
        `https://saas.tabebek.com/public/domainnmeapiSearch`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "*/*",
          },
          body: new URLSearchParams({
            domain_name: domainName,
          }),
        }
      );

      const result = await response.json();
      setDomainObj(result);

      if (result?.data === 0) {
        setError(null);
        onValidDomain?.(domainName); // optional callback
      } else {
        setError("Invalid");
      }
    } catch (err) {
      console.error("Validation error:", err);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const debouncedValidation = useCallback(debounce(validateDomain, 1000), []);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    debouncedValidation(inputValue);
  };

  return (
    <div className="w-full">
      <label
        htmlFor="domainName"
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        Domain Name
      </label>
      <input
        id="domainName"
        type="text"
        name="customer_dmnname"
        value={value}
        onChange={handleChange}
        autoComplete="off"
        placeholder="Enter domain name..."
        className={`w-full border rounded-md px-3 py-2 focus:outline-none ${
          error
            ? "border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:ring-blue-500"
        }`}
      />
      {loading && (
        <p className="text-xs text-gray-500 mt-1">Checking domain...</p>
      )}
      {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
    </div>
  );
};

export default DomainSearchInput;
